module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapnum",
    attrs: {
      "id": "ch1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_xi"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rch1"
    }
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "chaptitle"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Contents#rch1"
    }
  }, [_vm._v("Good intentions but clueless")])])]), _vm._v(" "), _c('div', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "subheading0",
    attrs: {
      "id": "sec1"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "href": "#/Contents#rsec1"
    }
  }, [_vm._v("“Do your business, Gretchen!”")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("his November morning was way too wet and cold to be stomping around the “back forty” for any appreciable time. I looked at my watch: 7:23. If I didn’t get on the road by 7:30, I’d be late for work on a Monday — always a bad move.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Gretchen was not a stupid dog. She was a shepherd who didn’t like to be hurried. The place, the smells, the mood had to be just right before she deposited her treasure with Mother Earth. I had to remain calm or I’d botch the entire enterprise.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("“Do your business, Gretchen!” I repeated firmly, giving her leash a few gentle tugs.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("She sniffed a rotting tree stump and shoved her snout into a clump of grass with a bit of green lingering at the center. 7:24. This was not going to be an easy morning.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("I’m more than a little embarrassed to say it, but when Gretchen refused to focus on the business at hand, I would sing to her. Yes, sing. Right out there in the sleet, right there in my hooded trench coat and clunky rubber boots.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("She was partial to slow, melodic tunes with lots of cadence. This morning I decided to pull a guaranteed hit out of my walkies playlist: “Save Your Heart for Me” by Gary Lewis and the Playboys. I sang this song when I soothed her, brushed her fur and ran her bathwater. If "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("you sing a song and nobody except your dog is there to hear it, is it really so crazy?")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Was it the little whistle at the start of that song that she loved? I whistled the intro softly and then crooned:")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("“Walk along the lake with someone new / Have yourself a summer fling or two / But remember I’m in love with you / And save your heart for me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("She looked up at me with peaked brows. I could see Gretchen’s resolve melting.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("“When the summer moon is on the rise / And you’re dancing under starlit skies / Please don’t let the stars get in your eyes / Just save your heart for me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Of course she expected all four choruses, which fit nicely into my four-minute window.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("“Please remember I’m in love with you / So save your heart for me / Darling, sa-a-a-ve your heart for me.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("So Gretchen did her business. I said, “Good girl!” and her licorice lips curved into a smile.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("She knew all along what I wanted her to do. But the song was an understood token of exchange. I gave so she gave. Silly, softie me. Gretchen is gone, but after all these years, I still cry on cue if that song crosses my mind.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("So did I pick up after our Gretchen? The “back forty” where she did her business wasn’t really forty acres. That’s just what we called the 20-by-40-foot strip of wooded "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("property at the end of our back lawn. By the time the deed was done, I had exactly two minutes to slog back to the house, settle Gretchen inside, lose the boots, whip on the high heels and head off to work.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("So what did I do with the doo? I made sure that my husband Chuck and our young son Greg walked very carefully around the “back forty” until we had a chance to clean it up. That didn’t happen until spring, six months after we welcomed Gretchen to our house in a suburb north of Pittsburgh. This first reconnaissance and assault resulted in a large plastic tub filled with dog waste. Mission accomplished. But how should we dispose of the payload?")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Now I have an abiding respect for garbage collectors and the work they do. I did not want to throw this crap into plastic bags and leave it at the curb. What if it exploded in the compactor, spewing poop shrapnel in all directions? It was too grim to consider.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Since the exercise was taking on the bearing of a military campaign, Chuck suggested that we dig a latrine. So we simply carved out a long, shallow trench and buried Gretchen’s waste. We did this year after year — spring and fall — as part of the seasonal yard work. Would I do it that way again? Well, no.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("The property sloped down to a creek within view of the "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("trench, so poopy runoff was a distinct possibility. Maybe the pathogens and nitrogen in the waste simply dissipated in the soil and did no harm. Or maybe the pollutants seeped into the groundwater and into the stream and into the Allegheny River. But if damage was done, it was done long ago by a family who meant well but Just Didn’t Know Better.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading",
    attrs: {
      "id": "sec2"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Contents#rsec2"
    }
  }, [_vm._v("Dealing with dog doo: a speed-of-light history")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("nd why would they have known better? Back in the day, public health messages about pet waste were pretty basic: “Don’t touch it. Wash your hands right away if you do. Don’t let baby play with it or eat it. Dog doo is a stinky toxin. You could go blind or die. Oh, ick. Stay as far away as possible.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("But that wasn’t easy to do.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("There was a time when city dogs ran free. They did their business anywhere they had a mind to and it wasn’t your job to pick it up. Your job was to not step in it. One early public service message was “Curb Your Dog,” which meant urging your pet to “go” in the street near the curb. Then — bingo! — the next rainstorm could sweep that stockpile of poo down the nearest gutter. Once in a city’s storm sewer, it made its way into nearby waterways, i.e., "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("your beach, your recreational river or lake, your drinking water. That worked out nicely.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Decades after “Don’t Be a Litter Bug,” people-who-should-know told us to “Scoop the Poop.” This idea took a while to catch on, but catch on it did — much to the delight of plastic poop bag manufacturers and Pet People eager to feel good about recycling shopping bags. And it caught on just in time to help manage the droppings of an onslaught of pampered pooches.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("According to the American Pet Products Association (APPA), the number of dogs in the United States increased from 75 million two years earlier to 77.5 million in 2009–10. There is now one dog for every four people. Without stoop-and-scoop and dog parks, we city folk would be spending a good part of the day scraping crap off our shoes, possibly our ankles. As it is, around 60 percent of Dog People now pick up their dog’s poop. Another good percentage left at ground zero is removed thanks to the kindness of strangers.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("But wait — is this the end of the story? Most pet stewards have been well trained to pick up after their dogs (“Good girl; good boy!”). From the looks of things, a lion’s share of the nasty stuff has disappeared from our byways. But you don’t need to have a PhD in physics to know that it doesn’t simply vanish. Remember that exploding poop "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("shrapnel? Dog waste, tons and tons of it, is still being packed into garbage trucks and hauled off to its final resting place in the landfill. R.I.Poo.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Don’t even get me started on landfills! Have you ever toured a landfill? They are not happy little dumps with seagull haloes where the trash is consumed by the dirt to create heavenly soil under future subdivisions. There has never on God’s green Earth been a dump like that. But this is most people’s idea of a landfill.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Years ago dumps were simply smelly open pits where trash was buried — cafeterias for rats, mice and other scavengers. Over time, water leached through the contents, polluting nearby groundwater and sometimes poisoning pristine aquifers. But that’s no longer the case. Today’s sanitary landfills are specially designed structures in which engineered liners seal trash off from surrounding water, air, soil and rain.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Under these conditions, trash remains intact indefinitely. For “regular” decomposition by an ordinary-good-guy mix of microorganisms to occur, some oxygen needs to be present. Landfills are designed to be solid, compact and oxygen free. So organics simply sit there for a long time — forever, as far as anyone can tell, except that they are decomposed a little by special microorganisms that can live without "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("oxygen. This slow-motion demo crew gives off methane instead of carbon dioxide, the by-product produced by the regular-good-guy microorganisms.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Organics, including pet waste, degrade in landfills via anaerobic critters that live without oxygen and produce methane. This powerful greenhouse gas then seeps out and is ultimately released into the air through pipes and valves built into the landfill. Municipal solid waste (MSW) landfills are the third largest source of human-related methane emissions in the United States, accounting for approximately 17.5 percent of all these emissions in 2011."), _c('sup', [_vm._v("["), _c('span', {
    attrs: {
      "href": "#/Notes#ren1",
      "id": "en1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v("]")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("We have the technology to tap some of this gas as a power source. The US Department of Energy encourages recovering landfill gas and offers grants from the American Recovery and Reinvestment Act (ARRA) of 2009. But tapping it depends on whether authorities and businesses have the will and financing to invest in the necessary equipment.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("A thousand years from now archaeologists might be working these sites like King Tut’s tomb, finding our cabbage heads, Pokemon chips and plastic-shrouded dog turds still intact. They will wonder which of these objects were tools, which were fetishes and which were strictly ornamental.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Concluding that the mummified poop was used as a "), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("currency would be a good guess. There is so much of it! Plus the DNA of crap and greenbacks is similar, and the packets easily fit into your pocket. But the sizes vary. Did the larger ones have greater value? And these treasures are all so carefully wrapped and knotted in petroleum-based encasements. The Ancients must have believed that the mummified brown knobs had great value.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("I have gone off the deep end with this little story. But not so deep that we can’t dig our way out and get back to the point. The point being: once trainable Dog People cleaning up after their pets start thinking about where it goes and what happens to it, they have eaten Forbidden Fruit from the Tree of EcoKnowledge. Once we Know Better, we are cast forever out of the Garden of EcoIgnorance. And there is no turning back from Niggling Understanding. We can only choose to disregard it, deny it, make excuses or fix things for the better.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Deciding to “fix things for the better” leads to the next logical step: cycling your pet’s waste back to the Earth. Landfills sealed with liners are a half-measure for any organic material. According to the EPA, these liners will eventually crack."), _c('sup', [_vm._v("["), _c('span', {
    attrs: {
      "href": "#/Notes#ren2",
      "id": "en2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v("]")]), _vm._v(" Think system failure. Think earthquake. Think tectonic shifts.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("The Wisconsin Department of Natural Resources states: “Current landfill designs and practices do not "), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _vm._v("provide for degradation of landfilled organic wastes within a defined and reasonable timeframe. Un-degraded organic wastes can potentially cause future environmental or economic impacts if the landfill gas and leachate collection and containment systems (cap and/or liner) fail at some time in the future. Potential economic burdens and environmental risks associated with these un-degraded wastes will be largely borne by future generations.”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Sad but true.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading",
    attrs: {
      "id": "sec3"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Contents#rsec3"
    }
  }, [_vm._v("Cat poo: another story altogether")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("“B")]), _vm._v("ring in the dog and put out the cat. Yakety yak (don’t talk back).” Back in ’58 when this Coasters song hit the airways, even city people routinely put out the cat at night. Kitty might return in the morning with a shredded ear, peculiar carcasses and fleas, but it was considered rather cruel not to let felines out to have their nefarious nighttime fun. And more years passed before Cat People felt the need to indulge kitties with their own indoor loos. The commercial production of clay litters and specially molded plastic boxes helped to seal the deal on indoor litter boxes.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Furthermore, today’s Cat People have a better appreciation of the dangers waiting to pounce on their pets just beyond the doorstep. Or maybe the world just seems like "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("a bigger, badder place. Busy highways are but a stone’s throw from residential neighborhoods. As suburbs encroach on hunting grounds, wild predators desperate for food pose real threats. As do Mean People everywhere. There are fewer hiding places. And we want to give our cats a chance to live all the nine lives their DNA has dealt them. Outside of rural mousers, most “owned” cats today are indoor or mostly-indoor pets.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Even in the days when city cats spent much of their time outdoors, we weren’t tripping over cat waste. Cats are fastidious creatures. A cat doesn’t poop in public on a whim like a Canada goose. Felines like their privacy and cover up after themselves on most occasions. But as anyone who cleans a litter box knows, their calling cards still pile up.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("According to a study done by the US Department of Agriculture, the typical dog generates ¾ of a pound (340 g) of waste a day — or 275 pounds (125 kg) per "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("year. This author and her Cat People friends found that an average cat produces significantly less poop every day: a carbon paw print of a third of a pound (150 g), if you factor in clumping clay litter. Yes — we weighed it. That makes a single cat’s annual output 110 pounds (55 kg).")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Let’s put this whole cat waste vs. dog waste thing in perspective right now: dog waste is a much bigger nuisance than cat waste. Dog waste is public, it is destructive, it piles up in gargantuan proportions. So we will be spending much of our time dealing with the many social and environmental complications related to dog doo. But this book will give the cats equal time when it comes to recycling solutions.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading",
    attrs: {
      "id": "sec4"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Contents#rsec4"
    }
  }, [_vm._v("How did I get into this crap?")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("T")]), _vm._v("he Denver area is teeming with dogs. Walk in any park and you’ll see them, every breed and combination of breeds known to man, parading like four-legged princes with stewards in tow. Two, three, four dogs tethered with clever lead arrangements are not uncommon. Talk to many of these Multi-Dog People and they will tell you that they believe dogs are happier in packs or that they want to adopt as many dogs as they can manage — just to give them homes forever. These reasons are truly edifying.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Across a park pathway you’re likely to see a willowy "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _vm._v("runner bending over to pick up after her vizsla. A little farther along a walker is doing a disappearing act with his cockapoo poo. Scan a panorama and you’ll see Dog People bobbing up and down like the Heckle and Jeckle oil pumps you see dotting the prairie. Or like those drinking birds that delight children by dipping again and again over a glass of water. It just gets you to thinking.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("In modern industrialized countries, human waste is flushed and treated, filtered and heated until it is safe enough to release or till back into the land. Whatever inefficiencies and absurdities are involved in the system, it’s working for now, as long as the water supply holds out. Meanwhile here we are, wrapping our dog’s turds in a piece of plastic and throwing them in the trash. How dumb is that?")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("There is no Barbara Woodhouse command that will stop healthy dogs from pooping. So how much of this stuff is out there? Are there better ways to handle this? Is anyone doing it? Is anybody even considering doing it?")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("These questions about how pet waste impacts the environment started nibbling away at the corners of my curiosity. I did a few casual online searches. Each answer made me more uncomfortable and led to more questions. Then I did some simple math and found out how a little scoop here and a little bagful there add up to Serious Tonnage. "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _vm._v("That hooked me. Now the Dona Quixote of Doo, I made phone calls, exchanged e-mails and chalked up some miles to satisfy my curiosity. And I became convinced about the feasibility of turning dog waste into a safe and productive soil amendment.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("I found a pet scoop pro and a composting wizard who were asking the same questions. We all wanted to know if we could turn this environmental liability into a garden gold legacy. Our dogwaste composting experiment produced a fragrant soil amendment that met EPA regulations and teemed with nutrients and the good biology that plants love (see below, Mission possible: “gold star” DW compost). Green Pet Compost in Oregon"), _c('sup', [_vm._v("["), _c('span', {
    attrs: {
      "href": "#/Notes#ren3",
      "id": "en3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v("]")]), _vm._v(" and the Tompkins County Dog Owners Group in New York"), _c('sup', [_vm._v("["), _c('span', {
    attrs: {
      "href": "#/Notes#ren4",
      "id": "en4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v("]")]), _vm._v(" successfully conducted similar projects. So this is a physically possible, physically replicable process. No one considered our unconventional composting sensational. What we were doing was not compelling or sexy, like a new cash-back credit card offer. But word slowly made its way to the local news media, blogs and online forums for dog, sustainability and gardening enthusiasts.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Eco-conscious pet stewards, scoopers, dog day care owners, pet sitters, veterinarians and park administrators all over the United States and Canada began visiting our EnviroWagg website and contacting us. Every one "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _vm._v("of them hoped that we had solutions to their hound and kitty mounds. So the dialogue began.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("They asked us questions and we did our best to come up with solutions that would work for their situations. They told us in no uncertain terms what worked and what went over like poop shrapnel. And we’re passing along this mother lode of data to you.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("How to begin? Let’s put on our hip boots and wade into some stats on sheer quantity.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading",
    attrs: {
      "id": "sec5"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Contents#rsec5"
    }
  }, [_vm._v("Piled higher and deeper")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("f you pick up after your dog and deposit a little wrapped parcel into the nearest trash can, it seems like such a tiny contribution. A BM (bowel movement) this morning, another BM later in the day. You pick up. You are a good steward. Some jerks don’t pick up at all. Sometimes you even pick up for them. These little presents don’t seem like much in the grand scheme of garbagedom.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("However, if you pitch waste from even one dog into your home trash, you know that it can be the heaviest item in the bag. On the plus side, your doo adds ballast that anchors your trash on a windy day. On the minus, you have a very real reminder of your pooch’s carbon paw print. And it ain’t pretty. The average dog produces 275 pounds (125 kg) of waste per year.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _vm._v("If you serve multiple dogs or pet sit, your reality checks multiply. If you run a scooper service, kennel, dog park, mush dog yard or vet clinic, pet waste can be 75 percent or more of your refuse. These are the folks who really do get to thinking and looking for practical solutions to an obviously mounting problem. Here’s where theory becomes disposal dilemma.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Now I don’t have a PhD in statistics, but I can handle simple math. Here’s the real scoop on how much our dogs generate.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading1"
  }, [_c('span', [_vm._v("Dog stats")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("83 million dogs in US households (US Humane Society)")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("On average, each dog produces 0.75 lb. of waste per day (US Dept. of Agriculture).")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("83 million dogs produce 62,250,000 lb. of waste per day.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Divided by 2,000 = 31,125 tons per day.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Times 365 = 11,360,625 tons (10,300,000 tonnes) per year.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Let’s be conservative, round it off and say 11 million tons (10 million tonnes) of dog waste per year.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_vm._v("What does that look like?")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("11M tons of dog waste = 22,000,000,000 lb. (22 G lb.)")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Dog waste weighs approximately 35 lb. per cu. foot (yes, we weighed it).")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("22,000,000,000 lb. of dog waste divided by 35 = 628,571,429 cu. ft.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("628,571,429 cu. ft. covers 62,857,143 sq. ft. and is 1 ft. deep.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_vm._v("How many football fields does that cover each year?")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("1 football field (including end zones) = 57,600 sq. ft.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("62,857,143 sq. ft. divided by 57,600 sq. ft. = 1,091 football fields 1 ft. deep or 109 football fields 10 ft. (3 m) deep.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Of course, we’re not tipping the entire contents of these football fields into landfills. Let’s overlook dog waste in rural areas where the need for pickup is not vital to sanitation and sanity. Country dogs have always been happy-go-lucky rascals when it comes to pooping. They have so much space for romping, they deposit their calling cards like wild animal scat — more social networking than nuisance.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Chances are good you won’t run into country canine doodles unless you’re doing some serious tracking. And Mother Nature happily gathers that well-dispersed poo into the folds of her big loving skirts. On the other hand, in urban areas with populations greater than 30,000, around 60 percent of the community’s dog waste is scooped and trashed. What does that look like?")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("Let’s take Colorado as an example. As the 22"), _c('sup', [_vm._v("nd")]), _vm._v(" most populous state in the United States, it’s right around the middle of the pack.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("635,550 dogs in Colorado’s 19 cities with populations of 30,000+")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("On average, each dog produces 0.75 lb. of waste per day.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("635,500 dogs produce 476,625 lb. per day.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Divided by 2,000 = 238.3 tons per day.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Times 365 = 86,984 tons per year.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Times 60% = 52,190 tons (47,174 tonnes) picked up/streamed into landfills.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("The Statue of Liberty weighs 225 tons. 52,190 tons divided by 225 tons = 232.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("All the Colorado dog waste streamed into landfills each year weighs as much as 232 Statues of Liberty.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Now consider this: 50,000-plus tons of the state’s dog excrement per year adds up to a very, very, very gargantuan pig lot or stockyard or dairy farm. If you could locate a poo bomb this massive in a single location on Google Earth, it would scream for regulation and treatment. But you can’t, so it doesn’t.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("How does dog waste stack up against other waste streams? A recent audit found that pet waste makes up 3.8 percent of the garbage from residential collections in San Francisco."), _c('sup', [_vm._v("["), _c('span', {
    attrs: {
      "href": "#/Notes#ren5",
      "id": "en5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")]), _vm._v("]")]), _vm._v(" In 2006, the City of Toronto found that dog "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _vm._v("waste is the largest litter stream by weight in its public parks."), _c('sup', [_vm._v("["), _c('span', {
    attrs: {
      "href": "#/Notes#ren6",
      "id": "en6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v("]")]), _vm._v(" The popularity of off-leash dog parks is growing big time. Our collection experience has shown that trash bins at these sites often contain 85 percent dog waste.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("In 2006 Colorado disposed of 34,000 tons of #1 and #2 plastics. That’s 34,000 tons of used plastics vs. 50,000+ tons of dog waste. Recycling programs diverted 20 percent of #1 and #2 plastics from landfills."), _c('sup', [_vm._v("["), _c('span', {
    attrs: {
      "href": "#/Notes#ren7",
      "id": "en7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")]), _vm._v("]")]), _vm._v(" So what’s the plan for the 52,194.27 tons of dog waste generated annually? Sadly, there isn’t one.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Plastic recycling is more energy intense than organics recycling practices such as composting. Many forward-leaning cities and towns are recycling yard waste and food scraps. Unlike metals, glass and plastics, these organics release large amounts of the methane released from landfills during the slow anaerobic decomposition process. But the same cities are ignoring pet waste. Is this simply because it’s … icky? Communities focusing on reaching zero-waste goals will need to find solutions for this nontraditional waste stream that do not include denial.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Cats outnumber dogs but generate less waste. When you add clumping clay litter, each cat contributes around one third of a pound (150 g) of waste to daily trash. Since there is no way to calculate the amount of cat waste deposited in indoor litter boxes vs. outdoors, let’s look at simple "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }), _vm._v("kitty poo production. Like dogs, the cats are hard at work.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading10"
  }, [_c('span', [_vm._v("Cat stats")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("96 million cats in US households (US Humane Society)")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("On average, each cat produces 0.3 lb. of waste/litter residue per day.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("96 million cats generate 28,800,000 lb. of waste per day.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Divided by 2,000 = 14,400 tons per day.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Times 365 = 5 million tons (4.5 million tonnes) per year")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("That’s 500,000 dump trucks full of cat poop.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("There are no statistics on how much cat waste is streamed into landfills.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("A recent American Bird Conservancy (ABC) telephone survey indicates that 65 percent of all respondents believe that keeping cats indoors is safer and healthier for cats.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_vm._v("Now check this data on Colorado’s city cats — pets most likely to use litter boxes and have their waste trashed.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("717,000 cats in Colorado’s 19 cities with populations of 30,000+")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("On average, each cat produces 0.3 lb. of waste/litter residue per day.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("717,000 cats produce 205,100 lb. per day.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Divided by 2,000 = 102.55 tons per day.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Times 365 = 37,430.75 tons per year streamed into landfills")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("Let’s add that total to the 52,194.27 tons of trashed dog waste from Colorado’s 19 cities with populations of 30,000+")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("37,430.75 tons of cat waste + 52,194.27 tons dog waste = 89,625.02 tons of pet waste.")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_vm._v("What does that look like?")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("The Washington Monument weighs 81,120 tons.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("The Statue of Liberty weighs 225 tons.")])]), _vm._v(" "), _c('p', {
    staticClass: "bullp"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _vm._v("89,625.02 tons = one Washington Monument + 37 Statues of Liberty.")])]), _vm._v(" "), _c('p', {
    staticClass: "bull"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _c('span', {
    staticClass: "grey"
  }, [_vm._v("•")]), _c('span', {
    staticClass: "space"
  }), _c('span', {
    staticClass: "hide"
  }), _vm._v("All the Colorado urban dog and cat waste streamed into landfills each year weighs as much as one Washington Monument + 37 Statues of Liberty.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("The Internet offers online credit calculators that tally household carbon footprints. Determining factors include home square-footage, energy use, number of residents and travel. Why no mention of pets?")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading1"
  }, [_c('span', [_vm._v("Kitty footnotes")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("C")]), _vm._v("an cat waste be recycled the same ways as dog waste? For the most part, yes. The big difference is that dog waste is collected in plastic pickup bags and cat waste mixes with litter. Both of these commingled materials complicate recycling practices, and we will explain these complications. But you can recycle both waste streams the "), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _vm._v("same way and take similar precautions when dealing with the potential for canine- and feline-specific pathogens.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Just to keep things simple, every solution for dog waste recycling in this book also applies to cat waste — with three important feline exceptions.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading1"
  }, [_c('span', [_vm._v("1. Quit the clay")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_vm._v("Do not use clay-based cat litter if you plan to recycle cat poop. Clay will not decompose, and may inhibit the process and contaminate the resulting material. Look for corn-, wheat-, wood- and paper-based litters that will break down with other organic materials. An economical option is small animal-bedding pine pellets. Many people suggest slowly adding the pellets to familiar clay litters to entice cats to switch. But our cat Max quit clay cold turkey and accepted pellets almost too enthusiastically. He seems to like the smell of fresh pine. And this litter eliminates odor.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("The staff at the feed store where we buy our animal bedding told us that quite a few locals use it as cat litter. Cleaning a litter box with pellets takes a bit of finesse, but is easy if you use an extra-wide (5 inch/12 cm) and deep litter scooper. Simply scoop out the poop and toss it into a waste bag. Then scoop up some of the urine-dampened pellet chunks and sift the sawdust into the same bag. "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("Throw the dry pellets back into the box. The litter box smells great, the pellets last a long time and the poop and sawdust compost beautifully! See “"), _c('span', {
    attrs: {
      "href": "#/Chapter003#Adapting",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Adapting dog/cat waste composting to space and climate")]), _vm._v(".”")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Environmentalists and holistic pet stewards criticize clay litter for being unfriendly to the earth because sodium bentonite, a popular constituent of clump cat litter, is obtained through strip mining. They also say that the substance is unhealthy for pets. Commercial litter often contains crystalline silica and various chemical concoctions to reduce odor. Other respected sources refute these negative claims against clay litter. The war of words will continue as long as there is money to be made manufacturing and marketing litter. These issues aside, for recycling purposes, do not use clay.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading1"
  }, [_c('span', [_vm._v("2. Do not flush cat waste")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_vm._v("Keep cat waste away from all water sources as the feces may contain Toxoplasma gondii, a disease agent toxic to sea otters. A California law"), _c('sup', [_vm._v("["), _c('span', {
    attrs: {
      "href": "#/Notes#ren8",
      "id": "en8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v("]")]), _vm._v(" requires commercial litter to include warnings such as, “Please do not flush cat litter in toilets or dispose of it outdoors in gutters or storm drains.” If you live east of the Rockies, your water flows to water uninhabited by otters. But we "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("don’t know if T. gondii affects other species of marine mammals, so why not be cautious?")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("So much for flushable cat litter and training kitty to perch on the toilet seat.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading1"
  }, [_c('span', [_vm._v("3. Do not deposit cat waste in doggie septic/biodigestion systems")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Dog-waste septic systems use anaerobic microorganisms to break down material in environments with little air, such as tanks. Septic starters are often added to promote natural bacterial growth. When the process flows along smoothly, the waste liquefies and is absorbed into the ground. Even plant-based litters can slow down the progress and clay litter will bung up the works entirely. So resist the urge.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading",
    attrs: {
      "id": "sec6"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Contents#rsec6"
    }
  }, [_vm._v("You take it. No, YOU take it.")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("W")]), _vm._v("aste management companies have been playing hot potato with pet waste and disposable diapers for decades. Agencies can’t agree on what to do with it. These organics are in the Twilight Zone of disposal management. This Canadian city’s story is not uncommon.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("“Some jurisdictions ban animal waste in domestic garbage as a potential health hazard since neither storage nor "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("means of transfer nor destination is planned or designed for this type of material. This is also true of Vancouver landfills, which specifically state that ‘all forms of excrement are prohibited from garbage disposal.’ ”"), _c('sup', [_vm._v("["), _c('span', {
    attrs: {
      "href": "#/Notes#ren9",
      "id": "en9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")]), _vm._v("]")])])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Commercial and municipal composters that routinely handle yard waste and even food scraps normally refuse to take pet waste for “health and sanitation reasons.” These professionals are always on their toes maintaining a proper balance of carbon, nitrogen, air, heat and moisture, so that the aerobic process moves merrily along. Who wants to throw in a monkey-wrench material that might result in more extensive monitoring, more odors, more scavengers, exotic pathogens and disgruntled neighbors?")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Of course, regardless of warnings and rules, pet poop slithers its way into the waste stream. Where else can it go? Dog People and Cat People will continue to disregard the warnings and wrap it up with the trash. They will continue to rake it into bags for recycling yard waste and toss it into bins for composting food scraps. Once pitched, this contraband crap will be properly processed like bathtub gin at a speakeasy. But isn’t it time to end the silly contradictions?")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Public health agencies and municipalities are all over the map when it comes to advice on pet waste disposal. "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("Some recommend that the stuff be double-bagged, pitched in the trash and never, ever composted. Others sponsor classes on how to recycle pet poo. Momentum appears to be on the side of official approval — and even encouragement — of safe practices that divert pet poop from landfills.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("The Environmental Protection Agency (EPA) says that agencies can suggest flushing dog waste down the toilet."), _c('sup', [_vm._v("["), _c('span', {
    attrs: {
      "href": "#/Notes#ren10",
      "id": "en10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")]), _vm._v("]")]), _vm._v(" Better check out potential snafus in the “"), _c('span', {
    attrs: {
      "href": "#/Chapter003#sec14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Flushing")]), _vm._v("” section.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Eco-conscious community leaders who see the zero-waste handwriting on the wall are taking the initiative in pet waste recycling. Officials in a number of cities are piloting programs that process all food scraps, yard waste and other compostable materials normally considered too contaminated to be recycled: meat, cheese, bones, greasy paper plates … and pet waste. Others are dog park pioneers.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Sustainability-minded Dog People in Ithaca, New York, maintained a dog waste composting program for several years that greatly reduced the tons of trashed raw feces their pets produced and turned it into compost that was safe and nutritious for plants. Volunteers at Notre-Dame-de-Grâce Dog Run in Montreal operate an ongoing dog waste-composting program that was the subject of a Concordia University study."), _c('sup', [_vm._v("["), _c('span', {
    attrs: {
      "href": "#/Notes#ren11",
      "id": "en11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")]), _vm._v("]")]), _vm._v(" Pacific Dog Park in Cambridge, Massachusetts, hosted the Park Spark Project,"), _c('sup', [_vm._v("["), _c('span', {
    attrs: {
      "href": "#/Notes#ren12",
      "id": "en12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v("]")]), _vm._v(" an "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("interactive art installation featuring a biodigester tank that converted dog waste into electricity to light the park.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Massive biodigesters have the advantage of producing useful residual material plus refuse-derived fuel (RDF). The City of Toronto has one of a growing number of public and privately operated large-scale digesters. These systems might provide the ultimate solution for dealing with nontraditional organic waste. See the sidebars “City of "), _c('span', {
    attrs: {
      "href": "#/Chapter003#Toronto",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Toronto’s green bin program")]), _vm._v("” and “The Park Spark Program,” both in the “"), _c('span', {
    attrs: {
      "href": "#/Chapter003#sec16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Biodigester/septic bin")]), _vm._v("” section.")])]), _vm._v(" "), _c('p', {
    staticClass: "subheading",
    attrs: {
      "id": "sec7"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/Contents#rsec7"
    }
  }, [_vm._v("Oh, ick … NOT!")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("L")]), _vm._v("et’s get this over with early on. Drop the poop phobia right now. Get a grip on the gag reflex. No OCD tailspins, please. If you want to recycle organics, you need to think like a techno-geek, not a loosey-goosey sixth grader.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Smelly stuff really, really, really repulses us — with good reason. Smelly stuff is associated with any organic material that is in the process of being digested by a microbial playground of protozoa, bacteria and fungi. If this degradation and transformation did not occur, life as we know it would simply not be possible.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("These microscopic critters don’t whistle while they work like the Seven Dwarfs. The ones that live in places "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("with no air (think waterlogged, sopping wet places) emit gases that we would describe as “putrid.” Microbes are so numerous, ubiquitous and diverse that just thinking about this amazing mini-universe can give you brain freeze. But some of them can poison us if we ingest them, so we have been hardwired to react with immediate aversion. Oh, ick! This is not the end of the microscopic critter story.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Mostly we see microbes in masses as mold on cheese or scum in the birdbath. But their many cousins are so versatile that they survive in every part of the biosphere, from the deepest ocean trenches to the highest mountains. Microbes live literally everywhere on Earth and even in the atmosphere. They are essential to our planet’s life cycle, eternal scavengers that decompose everything that once lived and plow it back into new life.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("People with a scientific bent spend entire lifetimes studying microbes. They teach courses, conduct research, publish tracts and speak at conferences. The Web gives them a platform to exchange information at online forums. If you want to know more about these cool microscopic creatures, go online and access academic resources plus lively discussions among highly accredited professionals. But for our purposes, just a few facts about microbes will help us weigh up our pet waste recycling options.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "boxtitlea"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _vm._v("Unscientific anecdotal litter byte")])]), _vm._v(" "), _c('p', {
    staticClass: "normalb"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _vm._v("A volunteer at shelter just west of Denver told me that feline respiratory problems decreased considerably when the facility switched from commercial clay litter to donated wood shavings.")])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("Each type of microscopic creature flourishes in its own comfort zone of heat, air and moisture — or lack thereof (love that word). Their little mojos grind to a halt when conditions around them change. At that point, a new species of tiny reinforcements rise up to take over.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("A "), _c('b', [_vm._v("mesophile")]), _vm._v(" is an organism that grows best in moderate temperatures between 68 and 113°F (20 and 45°C). These organisms are the keys to mesophilic processes — making cheese, yogurt, pickles and sauerkraut, and fermenting alcohol. Think about it the next time you enjoy a kraut dog with beer or Brie with Chardonnay. But let’s fast forward from gastronomy to pet waste disposal. This will take some effort on both our parts, but here goes.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("In addition to mesophiles there are "), _c('b', [_vm._v("thermophiles")]), _vm._v(" — microbes that like it hot and flourish in temperatures between 113 and 252°F (45 and 122°C) provided they have the right amounts of oxygen and water. Generally speaking, mostly anaerobic mesophiles (remember, anaerobic means able to live in the total absence of oxygen) take care of business in flushing, burial, septic "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("and bokashi scenarios while thermophiles step in when conditions are right for high-heat composting.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Another important distinction is between “good” and “bad” microbes. Some deep thinkers have observed that there are no good people or bad people, just good actions and bad ones. Gardeners often say that weeds are only weeds in the eyes of the beholder. The same can be said about microorganisms. For instance, moldy foods contaminated with tremorgenic mycotoxins will help fuel the action in a compost pile. But if your dog eats even a small amount, these microbes will make it sick within a few hours. Depending on the dose, Fido might even die."), _c('sup', [_vm._v("["), _c('span', {
    attrs: {
      "href": "#/Notes#ren13",
      "id": "en13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")]), _vm._v("]")]), _vm._v(" So practically speaking, experts do need to make the call on whether a microorganism is generally good or bad for us and those we nurture.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("Health care professionals know that microbial balance is essential to health. They can pinpoint bacteria and viruses that are dangerous to the well being of people, pets, wild animals and plants. Microorganisms that commonly wear black hats are called "), _c('b', [_vm._v("“pathogens.”")]), _vm._v(" Think of them as the Lee Van Cleefs of the microscopic universe. Although nothing organic is entirely free of pathogens, our goal is to limit them and facilitate healthy processes.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("At this point I also need to mention a fact you might already appreciate. All creatures with advanced digestive systems — including you and your pet — host a huge "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("population of diverse microorganisms in their guts. These are essential for breaking down the foods that nourish us. This waste management brigade evolved eons before we did, literally enabling us to exist as we do and enjoy the life we live. But there’s one little drawback in our relationship with microbes.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("The reason that smelly stuff really, really, really repulses us is that people are (wisely) inclined to back off when they get a whiff of methane, which they say “stinks.” This greenhouse gas is a necessary byproduct of anaerobic mesophilic microbial digestion. The bad smell tells us that potentially unfriendly microorganisms have called “dibs” on the food and are already working to degrade it.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("That odor can be a lifesaver because some of the microbes might be pathogens that can make us very sick. (Wouldn’t it be nice if our dogs were hardwired like that?) The smell intensifies in feces, which are crammed with millions of microorganisms busy digesting the food residue.")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_vm._v("So our reaction to bad smells (or even the anticipation of bad smells) runs from “oh, ick” through a more profound “oh, yuck” to quiet repulsion, depending on our sensibilities. Can we move on to Oh, Ick … NOT? Please? Are we going to be led around by our noses or our brains? We change diapers. We pick up after pets. We clean the aquarium and the toilet. Why the drama?")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("We apply mysterious man-made chemicals so that everything smells “springtime fresh,” yet we seal what smells — but is truly the elixir of future life — in plastic and throw it into a hermetically sealed but somewhat leaky tomb that oozes methane for a long, long time. If we want to recycle pet waste or any other organic, we need to get over hyperhygiene at inappropriate times. Common sense cleanliness is a very commendable habit; a necessity, even. But hyperhygiene is for food prep, decontaminating astronauts and removing spleens.")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "hide"
  }), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('p', {
    staticClass: "boxtitle"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _vm._v("No consistent public solutions")])]), _vm._v(" "), _c('p', {
    staticClass: "normalb"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _vm._v("The EPA’s most recent update to “Composting at Home” includes dog and cat waste in its list of “What NOT to compost,” citing that it “might contain parasites, bacteria, germs, pathogens, and viruses harmful to humans.” But it leaves policy and enforcement to local jurisdictions.")])]), _vm._v(" "), _c('p', {
    staticClass: "normalb-ts"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _vm._v("In National Pollutant Discharge Elimination System (NPDES), Pet Waste Management — the EPA states, “Deciding whether to encourage residents to dispose of pet waste in the trash, bury it in their yards, or flush it down the toilet is an important issue for communities.” Local authorities might insist that residents double-bag and trash pet waste or they might provide incentives for recycling it. Here are some responses:")])]), _vm._v(" "), _c('p', {
    staticClass: "normalb-ts"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _vm._v("Composting Pet Waste: Cost Share Available, Rivanna Regional Stormwater Education Partnership, North Carolina (“Depending on where you live, there are two sources of cost share funding for pet waste composters. Both programs will pay 50% of the cost of composter.”)")])]), _vm._v(" "), _c('p', {
    staticClass: "normalb-ts"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _vm._v("Let’s discuss Fluffy’s pet waste, Snohomish County, Washington State (“Pet feces and cat litter can be put in the garbage … double bagged in plastic and tied tightly.”)")])]), _vm._v(" "), _c('p', {
    staticClass: "normalb-ts"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _vm._v("Pet Waste Composting Comes to Kingston, CKWS TV News, Kingston, Ontario, July 2013 (“If you have a dog — there is a way to safely dispose of your pet waste without harming the environment. A local group is holding seminars next month on composting the waste.”)")])]), _vm._v(" "), _c('p', {
    staticClass: "normalb-ts"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _vm._v("Composting Questions and Answers, City of Houston, Official Site for Houston, Texas 2013 (“Do not compost pet waste. Not only are they smelly, but they can be dangerous to your health.”)")])]), _vm._v(" "), _c('p', {
    staticClass: "normalb-ts"
  }, [_c('span', [_c('span', {
    staticClass: "hide"
  }), _vm._v("Recycling center to put on composting event, "), _c('i', [_vm._v("The Joplin Globe,")]), _vm._v(" Joplin, Missouri, November 13, 2013 (“Members of the Chert Glades Master Naturalists will demonstrate how to make a dog waste digester.”)")])]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  }, [_c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "hide"
  })]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _vm._v("As you approach the practices outlined here, think of tolerating, controlling and eliminating odors as the small price you pay to work as a partner with nature. It’s the effort you contribute for taking responsibility for your pet’s carbon paw print. Once you appreciate the multitudes of microorganisms and the yeoman’s job they do for us, an “awe factor” should override the “ick factor.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7541ef56","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter001.vue
// module id = 75
// module chunks = 0